import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Result } from 'antd'

import { validateToken } from 'src/redux-store/actions/user-actions'

import Loader from 'src/components/Loader'
import Button from 'src/components/Button'

import { getToken, storeToken, redirectToLogin } from 'src/common/session'

const Auth = props => {
  const { children, user, loginFailed, location, history, validateTokenAction } = props

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const tokenParam = queryParams.get('token')
    if (tokenParam) storeToken(tokenParam)

    // Never empty right after SSO, so this cannot bounce a user straight back to it.
    const token = getToken()
    if (!token) {
      redirectToLogin()
      return
    }

    validateTokenAction(token)
    if (tokenParam) {
      queryParams.delete('token')
      history.replace(`${location.pathname}?${queryParams.toString()}`)
    }
  }, [history, location.pathname, location.search, validateTokenAction])

  // A manual retry is a click, so it starts one new round instead of a loop.
  if (loginFailed)
    return (
      <Result
        status={'warning'}
        title={<FormattedMessage id={'auth.failed.title'} />}
        subTitle={<FormattedMessage id={'auth.failed.description'} />}
        extra={
          <Button onClick={redirectToLogin}>
            <FormattedMessage id={'auth.failed.retry'} />
          </Button>
        }
      />
    )

  return isEmpty(user) ? <Loader /> : children
}
Auth.propTypes = {
  user: PropTypes.object,
  loginFailed: PropTypes.bool,
  validateTokenAction: PropTypes.func
}

const mapStateToProps = state => ({
  user: state.user.current,
  loginFailed: state.user.loginFailed
})
const mapDispatchToProps = {
  validateTokenAction: validateToken
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Auth))
